import { MaterializedConfig } from '@dtx-company/connect-codegen/src/gen/plans/v1/plans_pb'
import { useAtlas } from '@dtx-company/inter-app/src/hooks/atlas/useAtlas'

export function useRestrictedFlowpageLinkTypes(): string[] {
  const atlasData = useAtlas()
  //return a name of all disabled configs - link providers that are prohibited will be included
  return (
    atlasData?.usage?.['pages']?.configs?.reduce(
      (acc: string[], curr: MaterializedConfig): string[] => {
        if (curr.calculationType === 'toggle' && curr.configValue === 'false') {
          return acc.concat(curr.configName)
        }
        return acc
      },
      [] as string[]
    ) || []
  )
}
